var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { singleton } from "tsyringe";
import { DaySchedule, DaySecond, FULL_DAY, makeImmutable, TimeRange, WEEKDAY_NAMES, } from "../core";
import { makeDayScheduleMap, WeeklySchedule } from "../collections";
function isClosed(day) {
    return (day.type === "WHOLE_DAY" ||
        (day.time_range.start === 0 && day.time_range.stop === 0));
}
let ChannelScheduleParser = class ChannelScheduleParser {
    constructor() {
        makeImmutable(this);
    }
    parse(days) {
        const appendAccumulator = {};
        WEEKDAY_NAMES.forEach((weekday) => (appendAccumulator[weekday] = []));
        const sameDay = makeDayScheduleMap((weekday) => {
            const index = WEEKDAY_NAMES.indexOf(weekday);
            const day = days[index];
            if (day === undefined || isClosed(day)) {
                return DaySchedule.Empty;
            }
            const { start, stop } = day.time_range;
            if (stop <= FULL_DAY) {
                return DaySchedule.fromRanges([
                    TimeRange.fromRange({
                        from: DaySecond.fromNumber(start),
                        to: DaySecond.fromNumber(stop),
                    }),
                ]);
            }
            const { remainder } = DaySecond.multiDay(stop);
            const nextWeekday = WEEKDAY_NAMES[(index + 1) % WEEKDAY_NAMES.length];
            appendAccumulator[nextWeekday].push(TimeRange.fromRange({ from: DaySecond.First, to: remainder }));
            return DaySchedule.fromRanges([
                TimeRange.fromRange({
                    from: DaySecond.fromNumber(start),
                    to: DaySecond.Last,
                }),
            ]);
        });
        const overnightAppends = makeDayScheduleMap((weekday) => DaySchedule.fromRanges(appendAccumulator[weekday]));
        return { weeklySchedule: new WeeklySchedule(sameDay), overnightAppends };
    }
};
ChannelScheduleParser = __decorate([
    singleton(),
    __metadata("design:paramtypes", [])
], ChannelScheduleParser);
export { ChannelScheduleParser };
